import firebase from "firebase";
import firestore from "firebase/firestore";

var config = {
  apiKey: "AIzaSyCDHz6IA_FPiJOk54Dmk7ZJISy7wwsXve4",
  authDomain: "geolocation-app-mst.firebaseapp.com",
  databaseURL: "https://geolocation-app-mst.firebaseio.com",
  projectId: "geolocation-app-mst",
  storageBucket: "geolocation-app-mst.appspot.com",
  messagingSenderId: "201274688249",
  appId: "1:201274688249:web:1f47588a2f73038f081828",
  measurementId: "G-JQKZ3ZQFFH",
};
const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({});

export default firebaseApp.firestore();



// WEBPACK FOOTER //
// ./src/firebase/init.js